/**
 * Échelle Palier 1–4 réservée aux antennes AFEPT (cfa = 0).
 * Ne pas élargir sans validation métier : le reste de QUALIFOP
 * conserve Acquis / En cours / Non acquis (diplômant).
 */
export const AFEPT_PALIER_ANTENNE_IDS = [100009, 100011, 100015]

export const PALIER_LABELS = {
  palier4: 'Palier 4',
  palier3: 'Palier 3',
  palier2: 'Palier 2',
  palier1: 'Palier 1',
  notEvaluated: 'Non évalué',
  acquired: 'Palier 4',
  advanced: 'Palier 3',
  inProgress: 'Palier 2',
  notAcquired: 'Palier 1'
}

export const PALIER_TOOLTIPS = {
  palier4: "Est capable de s'adapter à des situations variées, peut aider un pair",
  palier3: 'Réalise de manière autonome les activités attendues',
  palier2: "Réalise des activités connues, a encore besoin d'aide",
  palier1: 'Découvre, réalise partiellement / avec difficulté une activité donnée',
  notEvaluated: 'Non évalué',
  acquired: "Est capable de s'adapter à des situations variées, peut aider un pair",
  advanced: 'Réalise de manière autonome les activités attendues',
  inProgress: "Réalise des activités connues, a encore besoin d'aide",
  notAcquired: 'Découvre, réalise partiellement / avec difficulté une activité donnée'
}

export function usesAfeptPalierScale(antenne) {
  return AFEPT_PALIER_ANTENNE_IDS.includes(Number(antenne?.id))
}

export function usesPalierEvaluationScale(antenne, typeActionFormation) {
  return typeActionFormation === 'NON DIPLOMANTE' || usesAfeptPalierScale(antenne)
}

export const DIPLOMANT_LABELS = {
  acquired: 'Acquis',
  inProgress: 'En cours',
  notAcquired: 'Non acquis',
  notEvaluated: 'Non évalué'
}

/**
 * Libellés diplômants.
 * Les évaluations pédagogiques restent sur Acquis / En cours / Non acquis.
 * Les tests de positionnement lisent pedagogie.positionnementScale.
 * Score 3 = niveau le plus haut, 2 = intermédiaire, 1 = le plus bas, 0 = non évalué.
 */
export function diplomantLabelsFromScale(scale) {
  if (!Array.isArray(scale) || scale.some((item) => Number(item.score) === 4)) {
    return DIPLOMANT_LABELS
  }
  const byScore = Object.fromEntries(
    scale.map((item) => [Number(item.score), item.label])
  )
  return {
    acquired: byScore[3] || DIPLOMANT_LABELS.acquired,
    inProgress: byScore[2] || DIPLOMANT_LABELS.inProgress,
    notAcquired: byScore[1] || DIPLOMANT_LABELS.notAcquired,
    notEvaluated: byScore[0] || DIPLOMANT_LABELS.notEvaluated
  }
}

export function cfaDiplomantLabels(store, typeEvaluation) {
  if (typeEvaluation !== 'POSITIONNING') return DIPLOMANT_LABELS
  const cfaId = store.state?.auth?.user?.antenne?.cfa?.id
  const getter = store.getters?.getCfaParams
  if (typeof getter !== 'function') return DIPLOMANT_LABELS
  const params = getter(cfaId, true) || getter(cfaId, false)
  return diplomantLabelsFromScale(params?.pedagogie?.positionnementScale)
}
